export default __webpack_public_path__ + "static/thumb-5a600bea32f6db0244d72a4b8194971f.png";